import React, { Suspense, useState } from 'react';

import { Availability } from '@/interface';

import CreateMeetingModal from '@/pages/dashboard/project/detail/meetings/components/CreateMeetingModal';
import EmailToggle from '@/pages/dashboard/project/detail/meetings/components/emailToggle';

interface PendingMeetingsProps {
  pendingMeetings: Availability[];
  projectId: string;
  selectedDate: Date;
}

const PendingMeetings: React.FC<PendingMeetingsProps> = ({ pendingMeetings, projectId, selectedDate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState<Availability | null>(null);

  const handleGenerate = (meeting: Availability) => {
    setSelectedMeeting(meeting);
    setIsModalOpen(true);
  };
  return (
    <div className="mx-2 sm:mx-6 space-y-3">
      {pendingMeetings.map((meeting) => (
        <div
          key={meeting.id}
          className="border border-cardClr-secondary bg-cardClr p-4 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 text-cardClr-text"
        >
          {/* Refined Header */}
          <div className="flex items-start justify-between gap-3 mb-3">
            <h4 className="font-semibold  text-base break-words leading-tight flex-1">{meeting.title}</h4>
            <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200 flex-shrink-0">
              ○ Available
            </span>
          </div>

          {/* Refined Time Slot */}
          {meeting.expert && (
            <div className="mb-3 p-3 bg-cardClr-secondary rounded-lg">
              <div className="flex items-center gap-2.5 mb-2">
                <div className="w-6 h-6 bg-cardClr rounded-md flex items-center justify-center flex-shrink-0">
                  <svg className="w-3.5 h-3.5 text-cardClr-text" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <div>
                  <span className="text-sm font-medium text-cardClr-text">{meeting.expert.name}</span>
                  <p className="text-xs text-cardClr-textSecondary">Participant</p>
                </div>
              </div>
              {meeting.expert && <EmailToggle email={meeting.expert.email} />}
            </div>
          )}

          {/* Refined Buttons */}
          <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={() => handleGenerate(meeting)}
              className="flex-1 sm:flex-none px-4 py-2 rounded-lg text-cardClr-secondary text-sm font-medium hover:bg-primary transition-all duration-200 flex items-center justify-center gap-2 bg-white"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Generate Meeting
            </button>
            {/* <button
              onClick={() => handleDelete(meeting.id)}
              className="flex-1 sm:flex-none px-4 py-2 rounded-lg border border-red-300 text-red-600 text-sm font-medium hover:bg-red-50 transition-all duration-200 flex items-center justify-center gap-2 bg-white"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
              Delete Slot
            </button> */}
          </div>
        </div>
      ))}

      <Suspense fallback={<div>Loading modal...</div>}>
        <CreateMeetingModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          meeting={selectedMeeting!}
          projectId={projectId}
          selectedDate={selectedDate}
        />
      </Suspense>
    </div>
  );
};

export default PendingMeetings;
